export const tweetConversion = text => {
  let result = text
  result = result.replace(/#/g, "%23").replace(/&/g, "%26")
  return result
}
